module.exports = __webpack_public_path__ + "assets/img/1c14180661c3002dc8a93ac54e7bfb6d.svg";